<form style="margin: 0px 0px 30px 0px;" name="preCheckoutSMS" class="needs-validation" [formGroup]="preCheckoutFormSMS" (ngSubmit)="onSubmit()" novalidate>
    <div>
        <label [class.label-invalid]="!validSMS()" translate>Código SMS</label>
        <div class="d-flex align-items-center input-group has-validations">
            <input class="form-control" aria-describedby="basic-sms" type="text" placeholder=" " formControlName="sms" id="sms" mask="000000" required/>
            
            <div class="input-group-append">
                <span class="input-group-text" id="basic-sms">
                    <fa-icon class="float-end" [icon]="['fas', 'sms']" size="lg"></fa-icon>
                </span>
            </div>
            <div *ngIf="!validSMS()" class="error" translate>
                O Código SMS informado é inválido
            </div>
        </div>

        <div style="margin: 30px 0px 0px 0px;">
            Não recebeu código via SMS?<br/>
            <span class="link-reenviar-notificacao" (click)="validaEnvioSMS()">Reenviar notificação</span>
            <br/><br/>
        </div>
    </div>

    <div class="container">
        <div class="row">
          <div class="col-sm" style="padding: 0 !important;">
            <div class="col next-button">
                <button type="submit" class="btn btn-primary" [disabled]="!validFormSMS()">
                    Validar código &nbsp;
                    <fa-icon class="float-end" [icon]="['fas', 'check']" size="lg"></fa-icon>
                </button>
            </div>
          </div>
        </div>
    </div>
</form>